import React from "react";

const AccountSettingsPage = () => {
  return <div></div>;
};

export default AccountSettingsPage;
